// Plain words shared by the upload report and the list of sets.

export const onOffLabel = (active) => (active ? "On" : "Off");

const KINDERGARTEN = 0;
const gradeLabel = (grade) => (grade === KINDERGARTEN ? "K" : String(grade));
const hasGrade = (grade) => grade !== null && grade !== undefined;

export const gradesLabel = (min, max) => {
  if (hasGrade(min) && hasGrade(max)) return `${gradeLabel(min)}–${gradeLabel(max)}`;
  if (hasGrade(min)) return `${gradeLabel(min)}+`;
  if (hasGrade(max)) return `up to ${gradeLabel(max)}`;
  return "Any";
};

export const classesLabel = (count) => (count === 1 ? "1 class" : `${count} classes`);

export const blankWhenZero = (count, label = String) => (count ? label(count) : "");
